import { Box, Link, makeStyles, Typography } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingTop: 20,
    paddingBottom: 20,
  },
}));
function Footer() {
  const classes = useStyles();

  return (
    <Box align="center" className={classes.root}>
      <Typography variant="subtitle2">
        <Link component="a" href="#" underline="none" color="textPrimary">
          Created by Soslan Tuaev - 2021
        </Link>
      </Typography>
    </Box>
  );
}

export default Footer;
